import { FileSpreadsheet, Cloud, FileText } from "lucide-react";
import DriveIcon from "./DriveIcon";

export const DriveExcelIcon = ({ size = 28 }) => {
  const badgeSize = size * 0.50;

  return (
    <div className="relative inline-flex" style={{ width: size, height: size }}>
      <FileText strokeWidth={1}  size={size} className="text-green-600" />
      <div className="absolute -bottom-1 -right-1 rounded-full bg-white p-[2px]">
        <DriveIcon size={badgeSize}/>
      </div>
    </div>
  );
};
